import { TagGroupOptions, TagGroupOptionsProps } from './TagGroupOptions';

export interface TagGroupOptionListProps<T extends { id: string; name: string }> {
  groups: TagGroupOptionsProps<T>[];
}

export const TagGroupOptionList = <T extends { id: string; name: string }>({
  groups,
}: TagGroupOptionListProps<T>) => (
  <div className="flex flex-col gap-y-3">
    {groups.map((group) => (
      <TagGroupOptions key={group.type} {...group} />
    ))}
  </div>
);
